module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lesson-footer"
  }, [(_vm.status === 'NOTICE') ? [_c('div', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.doReminder(_vm.product.code)
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.remind ? '已开启报名提醒' : '开始报名提醒我') + "\n    ")])] : (_vm.status === 'REGISTER') ? [(_vm.product.stock.left > 0) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.jump
    }
  }, [_vm._v("还剩" + _vm._s(_vm.product.stock.left) + "个名额，立即报名")]) : _c('div', {
    staticClass: "btn over"
  }, [_vm._v("来晚了，名额已满")])] : (_vm.status === 'OVER') ? [_c('div', {
    staticClass: "btn over"
  }, [_vm._v("已结束")])] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b2b8d06"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/app-product-detail/components/lesson/footer.vue
// module id = 1063
// module chunks = 2